import "./CarouselBanner.scss";

import React from "react";
import { Banner, BannerGroup } from "../../stores/BannerStore";
import { Carousel } from "react-bootstrap";
// @ts-ignore
import { TargetParams, PageType } from "../../utils/BannerContainer";
import ClickHandler from "./ClickHandler";
import { renderBannerTeaser } from "./Teaser";
import { trackBannerImpression } from "../../utils/BannerTrackingUtil";
import { Ad } from "./Ad";
import { getAdImages } from "../../utils/BannerUtil";

type Props = {
    banners: BannerGroup;
    targetParams?: TargetParams;
    pageType: PageType;
};
type CarouselState = {
    isPaused: boolean;
    activeIndex: number;
};

function getImpressionTrackingArray(banners: BannerGroup) {
    if (banners && banners.length > 0) {
        const impressions = Array(banners.length);
        impressions[0] = true; //first impression recorded , to review that but this is nw sits quite tight in BannerComponent
        return impressions.fill(false, 1, banners.length);
    } else {
        return [];
    }
}

class CarouselBanner extends React.Component<Props, CarouselState> {
    timeout: any;
    interval = 5000;
    impressionRecords: Array<boolean>;

    constructor(props: Props) {
        super(props);
        this.timeout = undefined;
        this.impressionRecords = getImpressionTrackingArray(this.props.banners);
        this.state = {
            isPaused: false,
            activeIndex: 0
        };
    }

    componentDidMount(): void {
        this.scheduleNext();
    }

    scheduleNext() {
        if (this.timeout === undefined) {
            this.timeout = setTimeout(() => {
                this.slideSelected(this.nextIndex());
            }, this.interval);
        }
    }

    nextIndex() {
        return this.state.activeIndex === this.props.banners.length - 1 ? 0 : this.state.activeIndex + 1;
    }

    cancelTimer() {
        if (this.timeout !== undefined) {
            clearTimeout(this.timeout);
            this.timeout = undefined;
        }
    }

    togglePause() {
        const pauseNow = !this.state.isPaused;
        this.setState({
            ...this.state,
            isPaused: pauseNow
        });
        if (pauseNow) {
            this.cancelTimer();
        } else {
            this.scheduleNext();
        }
    }

    recordImpression() {
        const activeIndex = this.state.activeIndex;
        const aciveBanner = this.props.banners[activeIndex];
        const carouselTargetParams = { ...this.props.targetParams, isCarouselMember: true };
        if (!this.impressionRecords[activeIndex]) {
            trackBannerImpression(aciveBanner, this.props.pageType, carouselTargetParams);
            this.impressionRecords[activeIndex] = true;
        }
    }

    slideSelected(selectedIndex: number) {
        this.cancelTimer();
        this.setState({ ...this.state, activeIndex: selectedIndex });
        this.recordImpression();
        if (!this.state.isPaused) {
            this.scheduleNext();
        }
    }

    isActiveIndex(slideIndex: number) {
        return this.state.activeIndex === slideIndex;
    }

    componentWillUnmount() {
        this.cancelTimer();
    }

    renderAd(banner: Banner) {
        return <Ad key={banner.placementId} images={getAdImages(banner)} />;
    }

    renderBanner(banners: BannerGroup) {
        const nextIcon = <span aria-hidden="true" className="carousel-arrow carousel-arrow-left" />;
        const prevIcon = <span aria-hidden="true" className="carousel-arrow carousel-arrow-right" />;
        const carouselTargetParams = { ...this.props.targetParams, isCarouselMember: true };
        const carouselItems = banners.map((banner: Banner, index: number) => {
            const content = banner.advertisement
                ? this.renderAd(banner)
                : renderBannerTeaser(banner, { className: "mfcss_teaser-full-page carousel-teaser" });
            return (
                <Carousel.Item key={index}>
                    <ClickHandler banner={banner} targetParams={carouselTargetParams} pageType={this.props.pageType}>
                        {content}
                    </ClickHandler>
                </Carousel.Item>
            );
        });
        const pauseResumeImge = this.state.isPaused ? "play.svg" : "pause.svg";
        return (
            <div className="margin-grid-top-2x">
                <Carousel
                    nextIcon={nextIcon}
                    prevIcon={prevIcon}
                    interval={null}
                    onSelect={(index: any) => {
                        this.slideSelected(index as number);
                    }}
                    pauseOnHover={false}
                    indicators={false}
                    activeIndex={this.state.activeIndex}>
                    {carouselItems}
                </Carousel>

                <div>
                    <div className="carousel-controls">
                        <div style={{ position: "relative" }}>
                            <img
                                className="pause-resume-toggle"
                                onClick={this.togglePause.bind(this)}
                                src={`/ordercapture/uidispatcher/static/app/assets/images/${pauseResumeImge}`}
                            />
                        </div>
                        <ol>
                            {banners.map((_: Banner, index: number) => {
                                return (
                                    <li
                                        key={`carousel-item-countrol-${index}`}
                                        className={this.isActiveIndex(index) ? "active" : ""}
                                        onClick={() => this.slideSelected(index)}></li>
                                );
                            })}
                        </ol>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const banners = this.props.banners;
        if (!banners || banners.length === 0) {
            return null;
        }
        return this.renderBanner(banners);
    }
}

export default CarouselBanner;
